<template>
    <VideoVariationLayout variation-modifier="slice-video--video-multiple" :primary="slice.primary" :video-players="videoPlayers" />
</template>

<script setup lang="ts">
    import {computed, onMounted} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VideoSlice, VideoSliceVideoMultiple} from '@prismicio-types';
    import useErrorHelpers from '../../../composables/useErrorHelpers';
    import {useVideoEmbedPlayer} from '../../../composables/useVideoEmbedPlayer';
    import VideoVariationLayout from '../VideoVariationLayout.vue';

    const props = defineProps(getSliceComponentProps<VideoSlice>());
    const slice = computed(() => props.slice as VideoSliceVideoMultiple);
    const {mapToVideoPlayerProps} = useVideoEmbedPlayer();

    const videoPlayers = computed(() =>
        slice.value.primary.items.map((item) =>
            mapToVideoPlayerProps({
                video: item.video,
                title: item.title,
                cover: item.cover,
                size: item.size,
            }),
        ),
    );

    onMounted(() => {
        const {getPreviewErrorHandler, throwIfItemsCountIsOutOfBound, throwIfMissingItemsProperties, throwIfPrimaryPropertiesAreInvalid} =
            useErrorHelpers();
        const errorHandler = getPreviewErrorHandler();
        if (errorHandler.enabled) {
            const itemsCount = slice.value.primary.items.length;
            throwIfItemsCountIsOutOfBound(errorHandler.toast, itemsCount, 'videos', 1, 3);
            throwIfMissingItemsProperties(errorHandler.toast, slice.value.primary.items, [{name: 'video', type: 'video'}], 'videos');
            throwIfPrimaryPropertiesAreInvalid(errorHandler.toast, props.slice.primary, [{name: 'title', type: 'field'}], 'video slice');
        }
    });
</script>
